import AudioRecorder from 'audio-recorder-polyfill'
window.MediaRecorder = window.MediaRecorder || AudioRecorder
